var Backbone, EmailFormUSLocationListElementView, SupportLocationListElementTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportLocationListElementTemplate = require('../../../../location_list_element_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationListElementView = (function(superClass) {
  extend(EmailFormUSLocationListElementView, superClass);

  function EmailFormUSLocationListElementView() {
    return EmailFormUSLocationListElementView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationListElementView.prototype.tagName = 'td';

  EmailFormUSLocationListElementView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportLocationListElementTemplate;
    return _.bindAll.apply(_, [this].concat(_.functions(this)));
  };

  EmailFormUSLocationListElementView.prototype.events = {
    'change .add': 'onChangeSelection'
  };

  EmailFormUSLocationListElementView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormUSLocationListElementView.prototype.toHash = function() {
    var locObj;
    locObj = this.options.location;
    locObj.isMarked = locObj.isSelected;
    if (locObj.isSelected) {
      locObj.checked = "checked";
    } else {
      locObj.checked = "";
    }
    locObj.firstLine = locObj.streetAddress1 + "," + locObj.city;
    locObj.secondLine = locObj.state + "," + locObj.postalCode;
    return locObj;
  };

  EmailFormUSLocationListElementView.prototype.onChangeSelection = function() {
    return this.options.location.isMarked = !this.options.location.isMarked;
  };

  return EmailFormUSLocationListElementView;

})(Backbone.View);

module.exports = EmailFormUSLocationListElementView;

//# sourceMappingURL=data:application/json;base64,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
